import NavbarLink from "./NavbarLink";
import { handleOpenChat } from "utils/analytics";

export default function Navbar(props: any) {
    return (
      <nav className={`hidden lg:flex ${ props.show ? "mobile" : "" }`}>
        <NavbarLink href="/" title="Home" />
        <NavbarLink href="/a-pousada" title="A Pousada" />
        <NavbarLink href="/acomodacoes" title="Acomodações" />
        <NavbarLink href="/como-chegar" title="Localização" />
        <div className="flex lg:hidden" title="" > 
          <div className="py-2 w-36 px-4 text-white bg-emerald-500 rounded text-center">
              <button onClick={handleOpenChat} type="submit">Fale conosco</button>
          </div>
        </div>
      </nav>
    )
}